import React from 'react';
import './PromotionsSection.css';

const PromotionsSection = () => (
  <div className="promotions-section">
    <div className="promo-card">
      <div className="promo-badge">🎉 Special Offer</div>
      <h4 className="promo-title">First Visit Discount</h4>
      <p className="promo-text">Get 10% off your first visit!</p>
      <div className="promo-code">
        <span className="promo-code__label">Use code:</span>
        <span className="promo-code__value">BABY10</span>
      </div>
      <p className="promo-expiry">Valid until March 31, 2026</p>
    </div>
    
    <div className="promo-card promo-card--secondary">
      <div className="promo-badge promo-badge--gold">⭐ Loyalty Reward</div>
      <h4 className="promo-title">Free Drink on 5th Visit</h4>
      <p className="promo-text">Join our Baby Club rewards program</p>
      <button className="promo-btn">Learn More</button>
    </div>
  </div>
);

export default PromotionsSection;
